import { Button } from "@mui/material"

const LexButton = ({children, ...props }) => {
    return <Button {...props} >{children}</Button>
};

export default LexButton;